import { render } from "./DeliveryImage.vue?vue&type=template&id=895ba1ba"
import script from "./DeliveryImage.vue?vue&type=script&lang=js"
export * from "./DeliveryImage.vue?vue&type=script&lang=js"

import "./DeliveryImage.vue?vue&type=style&index=0&id=895ba1ba&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__